import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import CircularProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/CircularProgress';
import PropTypes from 'prop-types';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import CheckIcon from '@material-ui/icons/Check';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import ErrorIcon from '@material-ui/icons/Error';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  iconWrapper: {
    marginRight: theme.spacing(1),
    width: 24,
    height: 24,
  },
  errorIcon: {
    color: theme.palette.facet.alertRed,
  },
  progressIcon: {
    verticalAlign: 'middle',
    color: theme.palette.facet.primaryGray,
  },
});

const getStatusIcon = (loadingState, classes) => {
  switch (loadingState) {
    case 'loading':
      return () => <CircularProgress className={classes.progressIcon} size={16} />;
    case 'error':
      return () => <ErrorIcon className={classes.errorIcon} size={16} width={16} />;
    default:
      return () => <CheckIcon color={'secondary'} size={16} width={16} />;
  }
};

const TextStatusIndicator = ({
  classes,
  loadingState,
  label,
  test,
}) => {
  const StatusIcon = getStatusIcon(loadingState, classes);

  return (
    <Box className={classes.root} test={test}>
      <Box className={classes.iconWrapper}>
        <Icon
          icon={StatusIcon}
        />
      </Box>
      <Text text={label} color="primaryGray" />
    </Box>
  );
};

TextStatusIndicator.defaultProps = {
  test: '',
};

TextStatusIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
  loadingState: PropTypes.oneOf(['loading', 'loaded', 'error']).isRequired,
  label: PropTypes.string.isRequired,
  test: PropTypes.string,
};

export default withStyles(styles)(TextStatusIndicator);
